import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Input, type InputProps } from '@/components/ui/input';

export type PasswordInputProps = Omit<InputProps, 'type' | 'suffix'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (props, ref) => {
    const { t } = useTranslation('admin');
    const [visible, setVisible] = useState(false);

    return (
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        suffix={
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="size-8 shrink-0 text-fg-tertiary hover:text-fg"
            aria-label={visible ? t('password.hide') : t('password.show')}
            aria-pressed={visible}
            onClick={() => setVisible((current) => !current)}
          >
            {visible ? <EyeOff className="size-4" aria-hidden /> : <Eye className="size-4" aria-hidden />}
          </Button>
        }
        {...props}
      />
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
